export default "__VITE_ASSET__C29duehv__"